import { render, staticRenderFns } from "./licDetail.vue?vue&type=template&id=6ddb7e71&scoped=true&"
import script from "./licDetail.vue?vue&type=script&lang=js&"
export * from "./licDetail.vue?vue&type=script&lang=js&"
import style0 from "./licDetail.vue?vue&type=style&index=0&id=6ddb7e71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb7e71",
  null
  
)

export default component.exports